<template>

	<div class="show_api_main_layout_phone"
		:style="now_show_api.id == 3 ? 'height: calc( 380px + (100vw - 60px - 10px) * 2 + 450px );' : ''">
		<div class="show_api_layout">
			<div class="show_api_item">
				<!-- <div :class="'show_api_item_icon '+ 'api_show_img_' + now_show_api.id">
							
					</div>
					<div class="show_api_item_title">
						{{now_show_api.title}}
					</div>
					<div class="show_api_item_text">
						{{now_show_api.content}}
					</div> -->
				<div :class="'page1_show_content_item_icon ' + 'api_show_img_' + now_show_api.id">

				</div>
				<div class="page1_show_content_item_title">
					{{ now_show_api.title }}
				</div>
				<div class="page1_show_content_item_text">

					{{ now_show_api.content }}
				</div>
				<div :class="'show_before_api_img ' + 'show_before_api_img_' + now_show_api.id"
					:style="now_show_api.id == 7 ? 'display: none;;' : ''">


				</div>
				<div class="before_to_after_arrow">

				</div>
				<div :class="'show_after_api_img ' + 'show_after_api_img_' + now_show_api.id"
					:style="now_show_api.id == 7 ? 'display: none;;' : ''">

				</div>

			</div>
			<div v-show="now_show_api.id == 3" class="api_ID_parameter_layout">
				<!-- {{now_show_api}} -->
				<div class="api_ID_parameter_size_layout">
					<el-radio-group class="ID_parameter_size_btn" v-model="ID_parameter_size_type"
						@change="radio_group_change">
						<el-radio :label="1">1寸</el-radio>
						<el-radio :label="2">2寸</el-radio>
						<el-radio :label="3">自定义</el-radio>
					</el-radio-group>
					<div class="api_ID_parameter_width_layout">
						<div class="api_ID_parameter_width_title">
							宽度(mm)：
						</div>
						<div class="api_ID_parameter_width_value">
							<el-input-number min="10" max="4096" v-model="api_ID_width" controls-position="right"
								:disabled="disabled_set_size" @change="api_ID_change" />
						</div>
					</div>
					<div class="api_ID_parameter_height_layout">
						<div class="api_ID_parameter_height_title">
							高度(mm)：
						</div>
						<div class="api_ID_parameter_height_value">
							<el-input-number min="10" max="4096" v-model="api_ID_height" controls-position="right"
								:disabled="disabled_set_size" @change="api_ID_change" />
						</div>
					</div>

				</div>
				<div class="api_ID_parameter_other_layout">
					<div class="api_parameter_bgcolor_layout">
						<div class="api_parameter_bgcolor_title">
							背景颜色：
						</div>
						<div class="api_parameter_bgcolor_value">
							<el-color-picker v-model="api_ID_bg_color" @change="api_ID_change" />
						</div>
					</div>
					<div class="api_parameter_format_layout">
						<div class="api_parameter_format_title">
							图片格式：
						</div>
						<div class="api_parameter_format_value">
							<el-select v-model="api_ID_bg_format" placeholder="Select" size="default"
								style="width: 130px" @change="api_ID_change">
								<el-option v-for="item in format_options" :key="item.value" :label="item.label"
									:value="item.value" />
							</el-select>
						</div>
					</div>

				</div>
			</div>
			<el-upload ref="uploadRef" v-model:file-list="fileList" class="upload_layout"
				:style="now_show_api.id == 3 ? 'margin-top: 640px;' : ''" :action="upload_action_url"
				:on-preview="handlePictureCardPreview" :on-progress="count_time" :on-remove="handleRemove"
				:on-error="handle_error" :on-success="handle_show_res_img" :before-upload="handle_before_upload_phone"
				list-type="picture-card" :limit="1" drag>
				<!-- 				<template #trigger>
				        <el-button type="primary">select file</el-button>
				    </template> -->
				<el-button type="primary" :style="now_show_api.id == 3 ? '' : ''">点击上传图片</el-button>
				<template #tip>
					<div class="el-upload__tip">
						<!-- 小于5MB的jpg/png文件 -->
					</div>
				</template>
			</el-upload>
			<div class="show_res_img"
				:style="now_show_api.id == 3 ? 'margin-top: calc((100vw - 60px - 10px) + 380px + 330px);' : now_show_api.id == 5 ? 'background-color: #030819;' : ''">
				<div class="load_res_img">

				</div>
				<!-- <img :src="res_img_data" alt="res Image" /> -->
				<el-image :src="res_img_data" :preview-src-list="uploadFile_list" :initial-index="0" :z-index="0"
					:zoom-rate="1.2" :max-scale="7" :min-scale="0.2">
					<template #error>
						<div class="image_slot_error">

						</div>
					</template>
				</el-image>
			</div>
			<!-- 			<div class="select_file_btn" @click="select_file_btn">
					点击上传图片
				</div> -->
			<div class="download_btn" @click="download_btn"
				:style="now_show_api.id == 3 ? 'margin-top: calc((100vw - 60px - 10px)*2 + 380px + 60px + 280px);' : ''">
				下载
			</div>
		</div>
	</div>
	<div class="show_api_main_layout">
		<div class="user_info_layout">
			用户：{{ now_user_name.length > 10 ? this.now_user_name.slice(0, 10) + '...' : this.now_user_name }}
			<div class="user_logout_btn" @click="user_logout_btn">
				退出
			</div>
		</div>
		<div class="show_api_layout">
			<div class="show_api_item">
				<!-- <div :class="'show_api_item_icon '+ 'api_show_img_' + now_show_api.id">
						
				</div>
				<div class="show_api_item_title">
					{{now_show_api.title}}
				</div>
				<div class="show_api_item_text">
					{{now_show_api.content}}
				</div> -->
				<div :class="'page1_show_content_item_icon ' + 'api_show_img_' + now_show_api.id">

				</div>
				<div class="page1_show_content_item_title">
					{{ now_show_api.title }}
				</div>
				<div class="page1_show_content_item_text">

					{{ now_show_api.content }}
				</div>
				<div :class="'show_before_api_img ' + 'show_before_api_img_' + now_show_api.id"
					:style="now_show_api.id == 7 || now_show_api.id == 8 || now_show_api.id == 9 ? 'display: none;;' : ''">

				</div>
				<div class="show_before_api_img"
					:style="now_show_api.id == 7 ? 'background-color: rgba(0, 0, 0, 0.0);padding-top: 20px;' : 'display: none;'">
					<el-select v-model="translate_from" placeholder="Select" size="default" style="width: 130px">
						<el-option v-for="item in translate_options_from" :key="item.value" :label="item.label"
							:value="item.value" />
					</el-select>
				</div>

				<div class="before_to_after_arrow"
					:style="now_show_api.id == 8 || now_show_api.id == 9 ? 'display: none;' : ''">

				</div>
				<div :class="'show_after_api_img ' + 'show_after_api_img_' + now_show_api.id"
					:style="now_show_api.id == 7 || now_show_api.id == 8 || now_show_api.id == 9 ? 'display: none;' : ''">

				</div>
				<div class="show_after_api_img"
					:style="now_show_api.id == 7 ? 'background-color: rgba(0, 0, 0, 0.0);padding-top: 20px;' : 'display: none;'">
					<el-select v-model="translate_to" placeholder="Select" size="default" style="width: 130px">
						<el-option v-for="item in translate_options" :key="item.value" :label="item.label"
							:value="item.value" />
					</el-select>
				</div>

			</div>
			<div v-show="now_show_api.id == 3" class="api_ID_parameter_layout">
				<!-- {{now_show_api}} -->
				<div class="api_ID_parameter_size_layout">
					<el-radio-group class="ID_parameter_size_btn" v-model="ID_parameter_size_type"
						@change="radio_group_change">
						<el-radio :label="1">1寸</el-radio>
						<el-radio :label="2">2寸</el-radio>
						<el-radio :label="3">自定义</el-radio>
					</el-radio-group>
					<div class="api_ID_parameter_width_layout">
						<div class="api_ID_parameter_width_title">
							宽度(mm)：
						</div>
						<div class="api_ID_parameter_width_value">
							<el-input-number min="10" max="4096" v-model="api_ID_width" controls-position="right"
								:disabled="disabled_set_size" @change="api_ID_change" />
						</div>
					</div>
					<div class="api_ID_parameter_height_layout">
						<div class="api_ID_parameter_height_title">
							高度(mm)：
						</div>
						<div class="api_ID_parameter_height_value">
							<el-input-number min="10" max="4096" v-model="api_ID_height" controls-position="right"
								:disabled="disabled_set_size" @change="api_ID_change" />
						</div>
					</div>

				</div>
				<div class="api_ID_parameter_other_layout">
					<div class="api_parameter_bgcolor_layout">
						<div class="api_parameter_bgcolor_title">
							背景颜色：
						</div>
						<div class="api_parameter_bgcolor_value">
							<el-color-picker v-model="api_ID_bg_color" @change="api_ID_change" />
						</div>
					</div>
					<div class="api_parameter_format_layout">
						<div class="api_parameter_format_title">
							图片格式：
						</div>
						<div class="api_parameter_format_value">
							<el-select v-model="api_ID_bg_format" placeholder="Select" size="default"
								style="width: 130px" @change="api_ID_change">
								<el-option v-for="item in format_options" :key="item.value" :label="item.label"
									:value="item.value" />
							</el-select>
						</div>
					</div>

				</div>
			</div>
			<div class="pay_mask_layout" @click="create_order" v-show="show_pay_mask">
				<img class="pay_img_layout" id="image" src="" alt="Image from Base64" v-show="is_pay">

				<div class="pay_mask_title">
					<span style="font-size: 50px;color: #0c8eff;">立即体验： </span>
					<span style="color: #00aaff;">0.01元/次</span>
					<div style="font-size: 20px;line-height: 40px;text-align: right;padding-right: 280px;">
						更多详情，敬请咨询，期待与您的合作！</div>
					<div style="font-size: 20px;line-height: 40px;text-align: right;padding-right: 280px;">
						联系电话：15927666885
					</div>
					<div style="font-size: 20px;line-height: 40px;text-align: right;padding-right: 280px;">
						公司邮箱：sales@doeasyai.com</div>
					<div style="font-size: 20px;line-height: 40px;text-align: right;padding-right: 280px;">
						联系地址：武汉市洪山区关东科技工业园</div>

				</div>
			</div>
			<div class="generate_swdt_input_layout" v-show="now_show_api.id == 6">
				<div class="generate_swdt_input">
					<el-input v-model="generate_swdt_input" :rows="16" type="textarea" placeholder="请输入思维导图的主题。"
						resize="none" style="font-size: 15px;" class="generate_swdt_input" />
				</div>
				<div class="generate_swdt_submit_btn" @click="submit_generate_swdt_data">
					点击生成
				</div>
			</div>
			<div class="generate_swdt_input_layout" v-show="now_show_api.id == 7">
				<div class="generate_swdt_input">
					<el-input v-model="translate_input" :rows="16" type="textarea" placeholder="请输入翻译内容。" resize="none"
						style="font-size: 15px;" class="generate_swdt_input" />
				</div>
				<div class="generate_swdt_submit_btn" @click="submit_translate_input_data">
					点击翻译
				</div>
			</div>
			<div class="generate_swdt_input_layout" v-show="now_show_api.id == 8">
				<div class="generate_swdt_input">
					<el-input v-model="generate_ppt_input" :rows="16" type="textarea" placeholder="请输入PPT的主题。"
						resize="none" style="font-size: 15px;" class="generate_swdt_input" />
				</div>
				<div class="generate_swdt_submit_btn" @click="submit_generate_ppt_data">
					点击生成
				</div>
			</div>
			<!-- <div class="show_res_img" v-show="now_show_api.id==7"> -->
			<div class="show_res_img" style="height: 370px;border: none;z-index: 97;" v-show="now_show_api.id == 7">
				<div class="load_res_img" style="z-index: 98;">

				</div>
				<el-input v-model="translate_output" :rows="16" type="textarea" placeholder="" resize="none"
					style="font-size: 15px;" class="generate_swdt_input" readonly />
			</div>
			<div class="show_res_img" style="height: 370px;border: none;z-index: 97;" v-show="now_show_api.id == 8">
				<div class="load_res_img" style="z-index: 98;">

				</div>
				<div class="show_res_ppt_img">

				</div>
			</div>
			<div class="show_res_img" style="height: 400px;border: none;z-index: 97;" v-show="now_show_api.id == 9">
				<div class="load_res_img" style="z-index: 98;">

				</div>
				<div class="show_res_docx_img">

				</div>
			</div>
			<!-- 				<div class="generate_swdt_submit_btn" @click="submit_translate_input_data" >
					点击翻译
				</div> -->
			<!-- </div> -->
			<el-upload ref="uploadRef_" v-model:file-list="fileList" class="upload_layout"
				:style="now_show_api.id == 3 ? 'margin-top: 360px;' : ''" :action="upload_action_url"
				:on-preview="handlePictureCardPreview" :on-progress="count_time" :on-remove="handleRemove"
				:on-error="handle_error" :on-success="handle_show_res_img" :before-upload="handle_before_upload"
				:list-type="now_show_api.id == 9 ? 'text' : 'picture-card'" drag
				v-show="now_show_api.id != 6 && now_show_api.id != 7 && now_show_api.id != 8">
				<!-- 
			   :limit="now_show_api.id==9?'10':'1'"
			   :multiple="now_show_api.id==9?'true':'false'"
			   -->
				<!-- 				<template #trigger>
			        <el-button type="primary">select file</el-button>
			    </template> -->
				<el-button type="primary" :style="now_show_api.id == 3 ? 'margin-top: 405px;' : ''">
					{{ now_show_api.id == 9 ? '点击上传文档' : '点击上传图片' }}
				</el-button>
				<template #tip>
					<div class="el-upload__tip">
						<!-- 小于5MB的jpg/png文件 -->
					</div>
				</template>
			</el-upload>
			<div class="show_res_img" :style="now_show_api.id == 3 ? 'margin-top: 360px;'
				: now_show_api.id == 5 ? 'background-color: #030819;'
					: now_show_api.id == 6 ? 'height:370px;'
						: now_show_api.id == 7 ? 'display: none;'
							: now_show_api.id == 8 ? 'display: none;'
								: now_show_api.id == 9 ? 'display: none;' : ''
				">
				<div class="load_res_img">

				</div>
				<!-- <img :src="res_img_data" alt="res Image" /> -->
				<el-image :src="res_img_data" :preview-src-list="uploadFile_list" :initial-index="0" :z-index="0"
					:zoom-rate="1.2" :max-scale="7" :min-scale="0.2" class="res_img_show_swdt"
					v-if="now_show_api.id == 6">
					<template #error>
						<div class="image_slot_error">

						</div>
					</template>
				</el-image>
				<el-image :src="res_img_data" :preview-src-list="uploadFile_list" :initial-index="0" :z-index="0"
					:zoom-rate="1.2" :max-scale="7" :min-scale="0.2" v-else>
					<template #error>
						<div class="image_slot_error">

						</div>
					</template>
				</el-image>
			</div>
			<!-- 			<div class="select_file_btn" @click="select_file_btn">
				点击上传图片
			</div> -->
			<div class="download_btn" @click="download_swdt" :style="now_show_api.id == 3 ? 'margin-top: 765px;' : ''"
				v-if="now_show_api.id == 6">
				下载
			</div>
			<div class="download_btn" @click="download_btn" :style="now_show_api.id == 3 ? 'margin-top: 765px;' : ''"
				v-else>
				下载
			</div>
		</div>
	</div>
	<Footer></Footer>

	<el-dialog v-model="dialogVisible">
		<img w-full :src="dialogImageUrl" alt="Preview Image" />
	</el-dialog>
</template>

<script>
import request from "@/utils/request";
import { ElNotification } from 'element-plus'
import Footer from '@/components/Footer'
import { ElMessage } from 'element-plus'

export default {
	name: "page4",
	components: {
		Footer
	},
	data() {
		return {
			translate_options: [
				{
					"value": "zh",
					"label": "中文"
				},
				{
					"value": "en",
					"label": "英文"
				},
				{
					"value": "ja",
					"label": "日文"
				},
				{
					"value": "ko",
					"label": "韩文"
				},
			],
			translate_options_from: [
				{
					"value": "zh",
					"label": "中文"
				},
				{
					"value": "en",
					"label": "英文"
				},
				{
					"value": "ja",
					"label": "日文"
				},
				{
					"value": "ko",
					"label": "韩文"
				},
				{
					"value": "auto",
					"label": "自动检测"
				},
			],
			translate_from: "zh",
			translate_to: "en",
			fileList: [],
			api_is_loading: false,
			generate_ppt_input: "",
			ppt_download_url: "",
			word_download_url: "",
			generate_swdt_input: "",
			translate_input: "",
			translate_output: "",
			check_order_id: "",
			is_pay: false,
			show_pay_mask: true,
			now_user_name: "",
			base_url: SERVER_URL,
			now_show_api: {},
			api_list_data: [],
			res_img_data: "",
			res_img_name: "",
			uploadFile_list: [],
			dialogVisible: false,
			dialogImageUrl: "",
			upload_action_url: "",
			api_ID_width: 295,
			api_ID_height: 413,
			api_ID_bg_color: "#618BCD",
			api_ID_bg_format: ".jpg",
			ID_parameter_size_type: 1,
			disabled_set_size: true,
			startTime: "",
			endTime: "",
			format_options: [
				{
					value: '.png',
					label: '.png',
				},
				{
					value: '.jpg',
					label: '.jpg',
				},
			]
			// one_user_detail:{},
			// one_user_detail_isShow:false,
			// user_detail_list:[],
			// add_new_user:false,
		}
	},
	beforeUnmount() {
		clearInterval(this.check_order_id)
	},
	updated() {
		let od_ = window.localStorage.getItem("od_")
		if ((od_ && od_ != 1) || this.now_user_name == "wzy") {
			this.show_pay_mask = false
		}
	},
	mounted() {
		let is_ok = this.init_data()

		if (is_ok) {
			let token = window.localStorage.getItem("token")
			this.now_user_name = token.slice(12, token.length)
			let od_ = window.localStorage.getItem("od_")
			if ((od_ && od_ != 1) || this.now_user_name == "wzy") {
				this.show_pay_mask = false
			}
		}

		// console.log(this.now_show_api)

		// request.get(this.$GLOBAL.flask_web_local_url+'/get_map_data_info').then(res => {
		// request.get("http://192.168.0.111:8002/").then(res => {
		// 	console.log(res)
		// })


	},
	beforeRouteUpdate(to, from, next) {

		this.init_data()
		next()
	},
	methods: {
		check_order() {
			console.log("check_order === ")
			let order_id = window.localStorage.getItem("od_key")
			// SERVER_URL_2
			// let order_id = "67846620250328102128111111"
			request.post("https://doeasyit.com/web" + '/check_order', { "order_id": order_id }).then(res => {
				// console.log(res)
				if (res.status != "200") {
					this.$message({
						type: "error",
						message: res.error_info
					})
				} else {
					// clearInterval(this.check_order_id)
					if (res.od_status == "已支付") {
						clearInterval(this.check_order_id)
						this.show_pay_mask = false
						this.is_pay = false
						window.localStorage.setItem("od_", order_id.slice(0, 6))
					}
				}
			}).catch(function () {
				ElMessage.error('服务器异常 ！！！')
			})
		},
		create_order() {
			if (!this.is_pay) {
				let user_token = window.localStorage.getItem("token")
				let data = {
					"token": user_token
				}
				// let pay_url = "http://192.168.1.10:9918/web"
				let pay_url = "https://doeasyit.com/web"

				request.post(pay_url + '/create_wx_order', data).then(res => {
					console.log(res)
					if (res.status != "200") {
						this.$message({
							type: "error",
							message: res.error_info
						})
					} else {
						// clearInterval(this.check_order_id)
						document.getElementById('image').src = 'data:image/jpeg;base64,' + res.data;
						this.is_pay = true
						window.localStorage.setItem("od_key", res.order_id)
						this.check_order_id = setInterval(this.check_order, 1000);
					}
				}).catch(function () {
					ElMessage.error('服务器异常 ！！！')
				})
			}

		},
		user_logout_btn() {
			window.localStorage.setItem("token", "")
			window.localStorage.setItem("od_", "")
			window.localStorage.setItem("od_key", "")
			clearInterval(this.check_order_id)
			this.$router.push("/main")//登录成功后跳转

		},
		reload_api_ID_action_url() {
			this.upload_action_url = this.base_url + "/handel_api_" + this.now_show_api.id
			// this.upload_action_url = "http://127.0.0.1:9917/api/handel_api_"+this.now_show_api.id
			this.upload_action_url += "?bg_color=" + this.api_ID_bg_color.replace("#", "")
			this.upload_action_url += "&width=" + this.api_ID_width
			this.upload_action_url += "&height=" + this.api_ID_height
			this.upload_action_url += "&img_format=" + this.api_ID_bg_format
		},
		api_ID_change() {
			if (!this.api_ID_width) {
				this.api_ID_width = 295
			}
			if (!this.api_ID_height) {
				this.api_ID_height = 413
			}
			this.reload_api_ID_action_url()
			// console.log(this.upload_action_url)
		},
		radio_group_change(val) {
			if (this.ID_parameter_size_type == 1) {
				this.disabled_set_size = true
				this.api_ID_width = 295
				this.api_ID_height = 413
			} else if (this.ID_parameter_size_type == 2) {
				this.disabled_set_size = true
				this.api_ID_width = 413
				this.api_ID_height = 626
			} else if (this.ID_parameter_size_type == 3) {
				this.disabled_set_size = false
				// this.api_ID_width = 413
				// this.api_ID_height = 626
			}
			this.reload_api_ID_action_url()
		},
		init_data() {
			document.getElementsByClassName("mainlayout_router_view")[0].scrollTop = 0

			this.api_list_data = this.$GLOBAL.api_list_data
			let show_index = window.localStorage.getItem("show_id")

			if (!show_index) {
				this.$router.push("/main")
				return false
			} else {
				let token = window.localStorage.getItem("token")
				// console.log(token)
				// console.log(!token)
				if (!token) {
					this.$router.push("/main/login")
					return false
				}
				this.$GLOBAL.methods.init_header_menu("page2")

				for (let i = 0; i < this.api_list_data.length; i++) {
					if (this.api_list_data[i].id == show_index) {
						this.now_show_api = this.api_list_data[i]
					}
				}
				if (this.now_show_api.id == 3) {
					// this.upload_action_url = SERVER_URL+"/handel_api_"+this.now_show_api.id
					// this.upload_action_url = "http://127.0.0.1:9917/api/handel_api_"+this.now_show_api.id
					this.reload_api_ID_action_url()

				} else if (this.now_show_api.id == 9) {
					this.upload_action_url = "https://doeasyit.com/web/upload_file"
				} else {
					this.upload_action_url = this.base_url + "/handel_api_" + this.now_show_api.id
					// this.upload_action_url = "http://127.0.0.1:9917/api/handel_api_"+this.now_show_api.id
				}
				// console.log(this.upload_action_url)
				this.handleRemove()
				this.$refs.uploadRef_.clearFiles()
				return true
			}
		},
		select_file_btn() {
			// console.log(this.$refs.uploadRef.handleStart())
		},
		handlePictureCardPreview(uploadFile) {
			if (this.now_show_api.id == 9) {
				return
			}
			this.dialogImageUrl = uploadFile.url
			this.dialogVisible = true
		},
		handle_before_upload() {
			// document.getElementsByClassName("el-upload-dragger")[0].style.display = "none"
			document.getElementsByClassName("el-upload")[0].style.display = "none"
			document.getElementsByClassName("el-upload")[1].style.display = "none"
			this.api_is_loading = true
			let objs = document.getElementsByClassName("load_res_img")
			for (let i = 0; i < objs.length; i++) {
				if (objs[i]) {
					objs[i].style.display = "block"
				}
			}

		},
		handle_before_upload_phone() {
			// document.getElementsByClassName("el-upload-dragger")[0].style.display = "none"
			document.getElementsByClassName("el-upload")[0].style.display = "none"
			let objs = document.getElementsByClassName("load_res_img")
			this.api_is_loading = true
			for (let i = 0; i < objs.length; i++) {
				if (objs[i]) {
					objs[i].style.display = "block"
				}
			}

		},
		handle_error() {
			ElMessage.error('图像上传失败 ！！！')
			document.getElementsByClassName("el-upload")[0].style.display = ""
			document.getElementsByClassName("el-upload")[1].style.display = ""
			let objs = document.getElementsByClassName("load_res_img")
			for (let i = 0; i < objs.length; i++) {
				if (objs[i]) {
					objs[i].style.display = "none"
				}
			}
		},
		handleRemove() {
			// document.getElementsByClassName("el-upload-dragger")[0].style.display = ""
			document.getElementsByClassName("el-upload")[0].style.display = ""
			document.getElementsByClassName("download_btn")[0].style.display = "none"
			document.getElementsByClassName("el-upload")[1].style.display = ""
			document.getElementsByClassName("download_btn")[1].style.display = "none"

			if (this.now_show_api.id == 9) {
				document.getElementsByClassName("show_res_docx_img")[0].style.display = "none"
			}

			this.res_img_data = ""
			this.uploadFile_list = []

			this.show_pay_mask = true
			let od_ = window.localStorage.getItem("od_")

			if ((od_ && od_ != "test") && this.now_user_name != "wzy") {
				console.log("reset -------------")
				window.localStorage.setItem("od_", 1)
			}

			console.log("handleRemove ----------------------")
		},
		count_time() {
			this.startTime = performance.now();


		},
		download_swdt() {
			const link = document.createElement('a');
			link.href = this.res_img_data;
			link.download = 'swdt.png'; // 指定下载的文件名
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		},
		submit_generate_ppt_data() {
			let od_ = this.check_is_test()
			if (od_ == "test_end") {
				this.show_pay_mask = true
				return
			}
			let ppt_text = this.generate_ppt_input
			if (ppt_text && !this.api_is_loading) {
				this.handle_before_upload()
				let translate_url = "https://doeasyit.com/web"
				request.post(translate_url + '/generate_ppt', {
					"text": ppt_text,
				}).then(res => {
					this.api_is_loading = false
					let base_url = "/home/lighthouse/doeasy_server_sanic/doeasy_api_server/res_ppt/"
					this.ppt_download_url = "https://doeasyit.com/web/download_file?file_path=" + base_url + res['data']
					console.log(this.ppt_download_url)
					// this.ppt_download_url = res['data']

					let objs = document.getElementsByClassName("load_res_img")
					for (let i = 0; i < objs.length; i++) {
						if (objs[i]) {
							objs[i].style.display = "none"
						}
					}

					document.getElementsByClassName("download_btn")[0].style.display = "inline-block"
					document.getElementsByClassName("download_btn")[1].style.display = "inline-block"

					document.getElementsByClassName("show_res_ppt_img")[0].style.display = "inline-block"
				}).catch(function () {
					ElMessage.error('服务器异常 ！！！')
				})
			}
		},
		submit_translate_input_data() {
			let od_ = this.check_is_test()
			if (od_ == "test_end") {
				this.show_pay_mask = true
				return
			}
			let translate_text = this.translate_input
			if (translate_text && !this.api_is_loading) {
				this.handle_before_upload()
				let translate_url = "https://doeasyit.com/web"
				request.post(translate_url + '/translate', {
					"text": translate_text,
					"from": this.translate_from,
					"to": this.translate_to
				}).then(res => {
					console.log(res)
					this.api_is_loading = false
					this.translate_output = res['data']
					if (this.translate_output == "QUERY LENGTH LIMIT EXCEEDED. MAX ALLOWED QUERY : 500 CHARS") {
						this.translate_output = "超出查询长度限制。允许的最大查询长度：500个字符"
					}
					// document.getElementsByClassName("download_btn")[0].style.display = "inline-block"
					// document.getElementsByClassName("download_btn")[1].style.display = "inline-block"
					let objs = document.getElementsByClassName("load_res_img")
					for (let i = 0; i < objs.length; i++) {
						if (objs[i]) {
							objs[i].style.display = "none"
						}
					}
				}).catch(function () {
					ElMessage.error('服务器异常 ！！！')
				})
			}
		},
		submit_generate_swdt_data() {
			let od_ = this.check_is_test()
			if (od_ == "test_end") {
				this.show_pay_mask = true
				return
			}
			let title = this.generate_swdt_input
			console.log(title)
			if (title && !this.api_is_loading) {
				this.handle_before_upload()
				// let generate_swdt_url = "http://192.168.1.10:6602/graph"
				// let generate_swdt_url = "http://aigcwzy.tpddns.cn:6602/graph"
				let generate_swdt_url = "https://doeasyit.com/web"

				this.uploadFile_list = []
				this.res_img_data = ""

				request.post(generate_swdt_url + '/generate_graph', {
					"text": title
				}).then(res => {
					this.api_is_loading = false
					console.log(res)
					if (res.status != "200") {
						this.$message({
							type: "error",
							message: res.error_info
						})
					} else {
						// clearInterval(this.check_order_id)
						this.res_img_data = `data:image/png;base64,${res.data}`;
						this.uploadFile_list.push(this.res_img_data)

						this.res_img_name = "swdt.png"

						document.getElementsByClassName("download_btn")[0].style.display = "inline-block"
						document.getElementsByClassName("download_btn")[1].style.display = "inline-block"
						let objs = document.getElementsByClassName("load_res_img")
						for (let i = 0; i < objs.length; i++) {
							if (objs[i]) {
								objs[i].style.display = "none"
							}
						}
					}
				}).catch(function () {
					ElMessage.error('服务器异常 ！！！')
				})
			}
		},
		check_is_test() {
			let od_ = window.localStorage.getItem("od_")
			if (od_ && od_ == "test") {
				// this.show_pay_mask = false
				window.localStorage.setItem("od_", "test_end")
			} else if (od_ && od_ == "test_end") {
				// this.show_pay_mask = false
				window.localStorage.setItem("od_", "1")
			}
			return od_
		},
		handle_show_res_img(res_data, UploadFile, UploadFiles) {

			this.check_is_test()
			if (this.now_show_api.id == 9) {
				document.getElementsByClassName("download_btn")[0].style.display = "inline-block"
				document.getElementsByClassName("download_btn")[1].style.display = "inline-block"
				document.getElementsByClassName("show_res_docx_img")[0].style.display = "inline-block"
				let objs = document.getElementsByClassName("load_res_img")
				for (let i = 0; i < objs.length; i++) {
					if (objs[i]) {
						objs[i].style.display = "none"
					}
				}
				this.word_download_url = "https://doeasyit.com/web/download_file?file_path=" + res_data['data']
				console.log(this.word_download_url)
				return
			}

			let endTime = performance.now();

			// console.log(endTime - this.startTime)

			// console.log(res_data)
			// this.res_img_data = res_data['img']
			this.res_img_data = `data:image/png;base64,${res_data['img']}`;
			this.uploadFile_list = []
			this.uploadFile_list.push(this.res_img_data)

			this.res_img_name = UploadFile.name
			document.getElementsByClassName("download_btn")[0].style.display = "inline-block"
			document.getElementsByClassName("download_btn")[1].style.display = "inline-block"
			let objs = document.getElementsByClassName("load_res_img")
			for (let i = 0; i < objs.length; i++) {
				if (objs[i]) {
					objs[i].style.display = "none"
				}
			}
			// console.log(UploadFile)

			// console.log(UploadFiles)
		},
		download_btn() {
			const a = document.createElement('a');
			// 创建一个a元素
			// request.get('http://192.168.0.111:8002/get_res_img/'+this.res_img_name)
			// 设置a元素的href属性为图片的URL
			if (this.now_show_api.id == 3) {
				a.href = this.base_url + '/get_res_img/' + this.now_show_api.id + "/" + this.res_img_name.split(".")[0] + this.api_ID_bg_format;
				// a.href = "http://127.0.0.1:9917/api/get_res_img/"+this.now_show_api.id + "/" + this.res_img_name.split(".")[0]+this.api_ID_bg_format;
			} else if (this.now_show_api.id == 5) {
				a.href = this.base_url + '/get_res_img/' + this.now_show_api.id + "/" + this.res_img_name.split(".")[0] + ".png";
				// a.href = "http://127.0.0.1:9917/api/get_res_img/"+this.now_show_api.id + "/" + this.res_img_name.split(".")[0]+".png";
			} else if (this.now_show_api.id == 8) {
				a.href = this.ppt_download_url
				// console.log(this.ppt_download_url)
			} else if (this.now_show_api.id == 9) {
				a.href = this.word_download_url
				// console.log(this.word_download_url)
			}
			else {
				a.href = this.base_url + '/get_res_img/' + this.now_show_api.id + "/" + this.res_img_name;
				// a.href = "http://127.0.0.1:9917/api/get_res_img/"+this.now_show_api.id + "/" + this.res_img_name;
			}
			// console.log(a.href)
			// 设置下载的文件名
			a.download = this.res_img_name || 'downloaded-image';
			// 将a元素添加到body中
			document.body.appendChild(a);
			// 触发点击事件
			a.click();
			// 从body中移除a元素
			document.body.removeChild(a);

		}
	}
}
</script>

<style></style>